import {
  styled,
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
} from "@mui/material";

const StyledTypography = styled(MuiTypography)(({ theme }) => {
  return {
    fontFamily: "Montserrat, sans-serif",
    color: theme.palette.brandedTypography?.textColor,
    "& a": {
      color: theme.palette.linkTypography?.textColor,
    },
  };
});

interface TypographyProps extends MuiTypographyProps {
  children: React.ReactNode;
}

export const Typography: React.FC<TypographyProps> = ({ children, ...props }) => {
  return <StyledTypography {...props}> {children}</StyledTypography>;
};

export default Typography;
